import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

const DEFAULT_FORM = {
  category: 'ddr_circuits_terminaux',
  name: '',
  existing_quantity: '',
  protection_type: '',
  ddr_ma: '',
  essai_ddr: '',
  insulation: ''
};

export default function DDRCircuitsTerminauxModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState(equipment || DEFAULT_FORM);

  useEffect(() => {
    setFormData(equipment || DEFAULT_FORM);
  }, [equipment, isOpen]);

  const handleSave = () => {
    onSave({
      type: 'ddr_circuits_terminaux',
      ...formData
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h2 style={styles.title}>
            {equipment ? '✏️ Modifier' : '➕ Ajouter'} DDR en circuits terminaux
          </h2>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        <div style={styles.subtitle}>
          📍 {local?.nom}
        </div>

        <div style={styles.content}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Désignation</label>
            <input
              type="text"
              value={formData.name || ''}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Ex: DDR Circuits terminaux..."
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Quantité</label>
            <input
              type="number"
              value={formData.existing_quantity || ''}
              onChange={(e) => setFormData({ ...formData, existing_quantity: e.target.value })}
              placeholder="Ex: 1, 2..."
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Protection</label>
            <select
              value={formData.protection_type || ''}
              onChange={(e) => setFormData({ ...formData, protection_type: e.target.value })}
              style={styles.select}
            >
              <option value="">Sélectionner...</option>
              <option value="ID2P">ID2P</option>
              <option value="ID4P">ID4P</option>
              <option value="DD21">DD21</option>
              <option value="DD22">DD22</option>
              <option value="DD33">DD33</option>
              <option value="DD43">DD43</option>
              <option value="DD44">DD44</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>DDR (mA)</label>
            <select
              value={formData.ddr_ma || ''}
              onChange={(e) => setFormData({ ...formData, ddr_ma: e.target.value })}
              style={styles.select}
            >
              <option value="">Sélectionner...</option>
              <option value="10">10 mA</option>
              <option value="30">30 mA</option>
              <option value="300">300 mA</option>
              <option value="500">500 mA</option>
              <option value="1000">1000 mA</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Essai DDR</label>
            <select
              value={formData.essai_ddr || ''}
              onChange={(e) => setFormData(prev => ({
                ...prev,
                essai_ddr: e.target.value,
                insulation: e.target.value === 'M' ? '>0,5' : prev.insulation
              }))}
              style={styles.select}
            >
              <option value="">Sélectionner...</option>
              <option value="B">B - Bon</option>
              <option value="M">M - Mauvais</option>
              <option value="NV">NV - Non vérifié</option>
            </select>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Isolement (MΩ)</label>
            <input
              type="text"
              list="isolement-options-ddr"
              value={formData.insulation || ''}
              onChange={(e) => setFormData({ ...formData, insulation: e.target.value })}
              placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              style={styles.input}
            />
            <datalist id="isolement-options-ddr">
              {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
            </datalist>
          </div>
        </div>

        <div style={styles.footer}>
          <button onClick={onClose} style={styles.cancelBtn}>
            Annuler
          </button>
          <button onClick={handleSave} style={styles.saveBtn}>
            {equipment ? 'Mettre à jour' : 'Ajouter'}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px'
  },
  modal: {
    background: 'white',
    borderRadius: '16px',
    width: '100%',
    maxWidth: '500px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
    borderBottom: '2px solid #e2e8f0'
  },
  title: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    color: '#1e293b'
  },
  subtitle: {
    padding: '12px 20px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#64748b',
    background: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#64748b',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '20px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    marginBottom: '6px',
    fontSize: '13px',
    fontWeight: 600,
    color: '#475569'
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    boxSizing: 'border-box',
    background: 'white'
  },
  footer: {
    display: 'flex',
    gap: '12px',
    padding: '20px',
    borderTop: '2px solid #e2e8f0'
  },
  cancelBtn: {
    flex: 1,
    padding: '14px',
    fontSize: '15px',
    fontWeight: 600,
    border: '2px solid #e2e8f0',
    borderRadius: '10px',
    background: 'white',
    color: '#64748b',
    cursor: 'pointer'
  },
  saveBtn: {
    flex: 1,
    padding: '14px',
    fontSize: '15px',
    fontWeight: 600,
    border: 'none',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    color: 'white',
    cursor: 'pointer'
  }
};